module.exports = "https://static.wmbcdn.com/uniweb/images/8eb557ca6dffdcb4e47ce1df6e1778dc.svg";